import { useSidePopup } from '../../../components/basic/popup/SidePopup'
import { TUTOR_PROFILE_TAB } from '../../../components/student/new-portal/tutors/TutorBody'
import TutorSideModalBody from '../../../components/student/new-portal/tutors/TutorSideModalBody'
import { AUTO_MATHCING_ID } from '../../../modules/vars'

interface TutorProfileSideModalOptions {
  overlayClose?: boolean
  border?: boolean
  bgWhite?: boolean
  maxW?: number
  hFull?: boolean
  gapFromTop?: number
  noTopSide?: boolean
}

const defaultOptions: TutorProfileSideModalOptions = {
  overlayClose: false,
  border: true,
  bgWhite: true,
  maxW: 448,
  hFull: true,
  gapFromTop: 0,
  noTopSide: true,
}
export const useTutorProfileSideModal = (options: TutorProfileSideModalOptions = {}) => {
  const finalOptions: TutorProfileSideModalOptions = { ...defaultOptions, ...options }
  const sidePopup = useSidePopup()
  return async (e, tutorId, isFeaturedTutor?, onClose?, type = TUTOR_PROFILE_TAB.SUMMARY, setResult?) => {
    try {
      e.preventDefault()
      e.stopPropagation()
      if (tutorId == AUTO_MATHCING_ID) return
      sidePopup.show({
        ...finalOptions,
        id: 'tutor-popup',
        onClose: () => {
          onClose ? onClose() : null
        },
        body: (
          <TutorSideModalBody id={tutorId} isFeaturedTutor={isFeaturedTutor} initialTab={type} setResult={setResult} />
        ),
      })
    } catch (error) {
      console.error(error)
    }
  }
}
